// extracted by mini-css-extract-plugin
module.exports = {"pagination":"styles_pagination__3SigQ","ant-select-selection-selected-value":"styles_ant-select-selection-selected-value__2oEvg","title":"styles_title__3SEQQ"};